export const MOBILE_WIDTH_BREAKPOINT = 768;
